import React, { Component, Fragment } from 'react'
import {
  Button,
  Paper,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Typography,
} from '@material-ui/core'
import moment from 'moment'

import WeedmapPinItemContainer from './WeedmapPinItemContainer'
import { isValidString } from '../../utils/string'
import ModalDialog from '../../components/common/ModalDialog'
import { Appcues } from '../../utils/constants'

const emptyPin = {
  name: '',
  apiKey: '',
  region: null,
}

export default class WeedmapPinContainer extends Component {
  state = {
    showEmptyPin: false,
    apiKeyListCopy: [],
    afterSave: null,
  }

  onPinUpdate = (data, afterSave) => {
    Appcues.track('Weedmap PIN Updated')

    const { apiKeyList, version = 1 } = this.props

    let apiKeyListCopy = [...apiKeyList]

    const index = apiKeyList.findIndex((key) => key.id === data.id)

    apiKeyListCopy[index] = {
      ...data,
      expiresIn: data.expiresIn ? moment(data.expiresIn).valueOf() : null,
    }

    if (!isValidString(data.name)) {
      return this.props.onError(`Pin name can't be empty`)
    }
    if ((version === 2 || version === 3) && !isValidString(data.listingWmId)) {
      return this.props.onError(`Listing ID can't be empty`)
    }

    if (version === 1 && !isValidString(data.apiKey)) {
      return this.props.onError(`API key can't be empty`)
    }

    if (this.checkV2Validations(data)) {
      if (this.checkForEnabled(data)) {
        this.props.onPinUpdate(apiKeyListCopy, afterSave)
      } else {
        this.setState({
          apiKeyListCopy,
          afterSave,
        })
      }
    }
  }

  onDelete = (data) => {
    Appcues.track('Weedmaps PIN Deleted')

    const { apiKeyList } = this.props

    let apiKeyListCopy = [...apiKeyList]

    const index = apiKeyList.findIndex((key) => key.id === data.id)

    apiKeyListCopy.splice(index, 1)

    this.props.onPinUpdate(apiKeyListCopy)
  }

  toogleEmptyPin = () => {
    Appcues.track('Adding Weedmaps PIN')
    this.setState((prevState) => ({
      showEmptyPin: !prevState.showEmptyPin,
    }))
  }

  addPin = (data, afterOnSave) => {
    Appcues.track('Weedmaps PIN Added')
    const { name, apiKey } = data
    const { version = 1 } = this.props

    if (!isValidString(name)) {
      return this.props.onError(`Pin name can't be empty`)
    }

    if (version === 1 && !isValidString(apiKey)) {
      return this.props.onError(`API key can't be empty`)
    }

    const { apiKeyList = [] } = this.props

    if (this.checkV2Validations(data)) {
      if (this.checkForEnabled(data)) {
        this.toogleEmptyPin()
        this.props.onPinUpdate([
          { ...data, expiresIn: data.expiresIn ? moment(data.expiresIn).valueOf() : null },
          ...apiKeyList,
        ])
      } else {
        this.setState({
          apiKeyListCopy: [
            { ...data, expiresIn: data.expiresIn ? moment(data.expiresIn).valueOf() : null },
            ...apiKeyList,
          ],
          afterSave: afterOnSave,
        })
      }
    }
  }

  checkV2Validations = (data) => {
    //const { version = 1 } = this.props;
    // if (version == 2) {
    //     if (!isValidString(data.clientId)) {
    //         this.props.onError("Client id cannot be empty");
    //         return false;
    //     }
    //     if (!isValidString(data.clientSecret)) {
    //         this.props.onError("Client secret cannot be empty");
    //         return false;
    //     }
    //        if (!isValidString(data.listingWmId)) {
    //            return this.props.onError(`Listing ID can't be empty`)
    //        }
    // }
    return true
  }

  checkForEnabled = (data) => {
    const { apiKeyList = [], version = 1 } = this.props
    let filteredKeyList = []
    if (version === 1) {
      filteredKeyList = apiKeyList.filter((key) => key.listingWmId)
    } else {
      filteredKeyList = apiKeyList.filter((key) => key.apiKey)
    }
    if (data.enabled) {
      if (filteredKeyList.filter((key) => key.enabled).length) {
        this.confirmModal.handleClickOpen()
        return false
      }
    }
    return true
  }

  onConfirm = () => {
    const { apiKeyListCopy, afterSave, showEmptyPin = false } = this.state
    const { version = 1 } = this.props
    let updatedApiKeyList = []

    if (version === 1) {
      updatedApiKeyList = apiKeyListCopy.map((key) => {
        if (key.listingWmId) {
          return { ...key, enabled: false }
        } else {
          return key
        }
      })
    } else {
      updatedApiKeyList = apiKeyListCopy.map((key) => {
        if (key.apiKey) {
          return { ...key, enabled: false }
        } else {
          return key
        }
      })
    }
    this.props.onPinUpdate(updatedApiKeyList, () => {
      this.confirmModal.handleClose()
      if (showEmptyPin) {
        this.toogleEmptyPin()
      }
      afterSave && afterSave()
    })
  }

  render() {
    const {
      apiKeyList = [],
      lastModified,
      regions = [],
      permitted = false,
      version = 1,
      authorizeWeedmapToken,
      renewWeedmapToken,
      weedmapsOrders = {},
    } = this.props

    const { showEmptyPin } = this.state

    const filteredApiKeyList =
      version === 1
        ? apiKeyList.filter((key) => key.apiKey)
        : apiKeyList.filter((key) => key.listingWmId)

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <h1>Weedmaps PINs</h1>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {permitted ? (
                  <Button
                    variant="raised"
                    className="primary-button pull-right margin-bottom-small"
                    onClick={this.toogleEmptyPin}
                  >
                    Add Pin
                  </Button>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="weedmap-pin-container full-width">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      {version !== 3 ? (
                        <TableCell>Pin Name</TableCell>
                      ) : (
                        <TableCell>Listing Name</TableCell>
                      )}
                      {version === 2 ? (
                        <Fragment>
                          {/*<TableCell>Client ID</TableCell>*/}
                          {/*<TableCell>Client Secret</TableCell>*/}
                          {/* <TableCell>Token</TableCell> */}
                          <TableCell>Listing ID</TableCell>
                          {/* <TableCell>Expired</TableCell> */}
                        </Fragment>
                      ) : null}
                      {version === 3 ? <TableCell>WMID</TableCell> : null}
                      {version === 1 ? <TableCell>API key</TableCell> : null}
                      {version !== 3 ? <TableCell>Regions</TableCell> : null}
                      {version === 2 ? (
                        <Fragment>
                          <TableCell>Token Status</TableCell>
                          <TableCell>Pin Expiration</TableCell>
                        </Fragment>
                      ) : null}
                      {version === 3 ? (
                        <Fragment>
                          <TableCell>Token Expiration</TableCell>
                        </Fragment>
                      ) : null}
                      <TableCell>Status</TableCell>
                      {version === 2 || version === 3 ? (
                        <Fragment>
                          <TableCell>Enable Online Orders</TableCell>
                          <TableCell>Delete Orders from WM</TableCell>
                        </Fragment>
                      ) : null}
                      {permitted ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyPin ? (
                      <WeedmapPinItemContainer
                        pin={emptyPin}
                        lastModified={lastModified}
                        onPinUpdate={this.addPin}
                        onCancel={this.toogleEmptyPin}
                        defaultEditMode={true}
                        regions={regions}
                        version={version}
                        weedmapsOrders={weedmapsOrders}
                      />
                    ) : null}
                    {filteredApiKeyList.map((row, index) => {
                      return (
                        <WeedmapPinItemContainer
                          key={index}
                          pin={row}
                          lastModified={lastModified}
                          onPinUpdate={this.onPinUpdate}
                          onDelete={this.onDelete}
                          regions={regions}
                          version={version}
                          authorizeWeedmapToken={authorizeWeedmapToken(index)}
                          renewWeedmapToken={renewWeedmapToken(index)}
                          weedmapsOrders={weedmapsOrders}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>
        <ModalDialog
          title={`Enabling version ${version} will disable the other versions`}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirm}
          confirmText="Yes"
          cancelText="No"
        >
          <Typography variant="subheading">Are you sure you want to proceed?</Typography>
        </ModalDialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedmapPinContainer.js